import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { resetPasswordRequest } from "../components/authApi";
import SeoManager from "../SeoManager";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  const handleReset = async (event) => {
    event.preventDefault();

    if (!token) {
      setStatus("error");
      setMessage("Invalid or missing token.");
      return;
    }

    setBusy(true);
    try {
      const data = await resetPasswordRequest(token, password, confirm);
      setStatus(data.status);
      setMessage(data.message);
    } catch (error) {
      console.error("Reset password error:", error);
      setStatus("error");
      setMessage("Unable to reset your password right now.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-page-wrap">
      <SeoManager
        title="Reset Password"
        description="Reset your Asher Jewels PH customer account password."
        path="/reset-password"
        robots="noindex,nofollow"
      />
      <div className="auth-page-panel auth-page-panel--compact">
        <p className="auth-shell__eyebrow">Account Recovery</p>
        <h1>Reset Password</h1>
        <p>Create a new secure password for your Asher Jewels customer account.</p>

        <form className="auth-modern-form" onSubmit={handleReset}>
          <label>
            New Password
            <input
              type="password"
              placeholder="Enter new password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </label>
          <label>
            Confirm Password
            <input
              type="password"
              placeholder="Confirm password"
              value={confirm}
              onChange={(event) => setConfirm(event.target.value)}
              required
            />
          </label>
          <button type="submit" className="auth-primary-button" disabled={busy}>
            {busy ? "Updating..." : "Update password"}
          </button>
        </form>

        {message ? (
          <p className={`auth-feedback ${status === "success" ? "auth-feedback--success" : "auth-feedback--error"}`}>{message}</p>
        ) : null}

        <Link to="/login" className="auth-text-link">Back to login</Link>
      </div>
    </div>
  );
}
